import { ThemeConfig } from "antd";

export const gweTheme: ThemeConfig = {
  token: {
    colorPrimary: '#C19966', // golden-1
    colorError: '#8C2504', // red
    colorSuccess: '#C19966', // golden-1
    colorText: '#636363', // gray-6
    colorTextHeading: '#C19966', // heading-color
    colorTextLabel: '#636363', // label-color
    colorLink: '#636363', // link-color
    colorBgBase: '#FFFFFF', // layout-body-background
    colorBgContainer: '#FFFFFF', // layout-header-background
    colorBorder: '#CCCCCC', // input-border-color
    colorBorderSecondary: '#BDBDBD', // gray-3
    borderRadius: 2,
    fontSize: 16,
    fontFamily: `'Lato', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB',
      'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif, 'Apple Color Emoji',
      'Segoe UI Emoji', 'Segoe UI Symbol'`,
    controlHeight: 40,
    colorBgLayout: '#FDFDFD',
    colorTextDisabled: '#636363',
    colorInfoBg: '#FDFDFD', // alert-error-bg-color
    colorTextPlaceholder: '#CCCCCC'
  },
  components: {
    Form: {
      labelColor: "#636363"
    },
    Button: {
      dangerShadow: "0 2px 0 rgba(255,38,5,0.06)"
    }
  }
};
